export default __webpack_public_path__ + "static/ourstory-feature-img-dd77fa318be2867489d6e7ca678ba9e1.webp";